import {useMutation} from '@tanstack/react-query';
import {getTelehealthMostRecentDate} from '../../services/getTelehealthMostRecentDate';
import {GetTelehealthMostRecentDateParams} from '../../services/getTelehealthMostRecentDate/types';

const useGetTelehealthMostRecentDate = (params: GetTelehealthMostRecentDateParams) => {
	return useMutation({
		mutationFn: () => getTelehealthMostRecentDate(params),
		retry: 2,
	});
};

export {useGetTelehealthMostRecentDate};
